import axios from "axios";
import { useState } from "react";
import { Check, Landmark, Pencil, Plus, Trash2, X } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayeeManager({ payees, onChanged }) {
  const [name, setName] = useState("");
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);
  const call = async (fn, success) => {
    setBusy(true); setNotice("");
    try { await fn(); setNotice(success); await onChanged?.(); return true; }
    catch (e) { setNotice(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "İşlem tamamlanamadı"); return false; }
    finally { setBusy(false); }
  };
  const add = async event => {
    event.preventDefault();
    if (name.trim() && await call(() => axios.post(`${API}/payees`, { name: name.trim() }), "Ödenen eklendi")) setName("");
  };
  const rename = async () => {
    if (draft.trim() && await call(() => axios.put(`${API}/payees/${encodeURIComponent(editing)}`, { name: draft.trim() }), "Ödenen güncellendi")) setEditing(null);
  };
  const remove = async () => {
    const target = pendingDelete; setPendingDelete(null);
    await call(() => axios.delete(`${API}/payees/${encodeURIComponent(target)}`), "Ödenen silindi");
  };
  return (
    <section className="panel account-manager" data-testid="payee-manager">
      <div className="panel-head"><div><p className="eyebrow">ÖDENENLER</p><h3>Parayı alan taraflar</h3></div><Landmark size={18}/></div>
      <form className="group-form" onSubmit={add} data-testid="payee-create-form">
        <input aria-label="Yeni ödenen" data-testid="new-payee-input" placeholder="Ör: RM Global Türkiye" maxLength={80} required value={name} onChange={e => setName(e.target.value)}/>
        <button className="outline-btn" type="submit" disabled={busy || !name.trim()} data-testid="add-payee-button"><Plus size={16}/> Ekle</button>
      </form>
      <div className="group-chips" data-testid="payee-chips">
        {payees.map(payee => editing === payee ? (
          <span className="group-tag editing" key={payee} data-testid={`payee-edit-${payee}`}>
            <input aria-label="Ödenen adı" autoFocus maxLength={80} data-testid="payee-rename-input" value={draft} onChange={e => setDraft(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); rename(); } if (e.key === "Escape") setEditing(null); }}/>
            <button className="chip-btn" title="Kaydet" disabled={busy || !draft.trim()} onClick={rename} data-testid="payee-rename-save"><Check size={14}/></button>
            <button className="chip-btn" title="Vazgeç" onClick={() => setEditing(null)} data-testid="payee-rename-cancel"><X size={14}/></button>
          </span>
        ) : (
          <span className="group-tag" key={payee} data-testid={`payee-chip-${payee}`}>
            {payee}
            <button className="chip-btn" title="Yeniden adlandır" disabled={busy} data-testid={`payee-rename-${payee}`} onClick={() => { setEditing(payee); setDraft(payee); }}><Pencil size={12}/></button>
            <button className="chip-btn danger" title="Sil" disabled={busy} data-testid={`payee-delete-${payee}`} onClick={() => setPendingDelete(payee)}><Trash2 size={12}/></button>
          </span>
        ))}
      </div>
      {notice && <p role="status" className="notice" data-testid="payee-notice">{notice}</p>}
      <AlertDialog open={!!pendingDelete} onOpenChange={open => !open && setPendingDelete(null)}>
        <AlertDialogContent data-testid="payee-delete-dialog">
          <AlertDialogHeader><AlertDialogTitle>Ödenen silinsin mi?</AlertDialogTitle>
            <AlertDialogDescription><b>{pendingDelete}</b> silinecek. Bağlı tahsilatı bulunan ödenenler silinemez.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel data-testid="payee-delete-cancel">Vazgeç</AlertDialogCancel>
            <AlertDialogAction className="danger-action" onClick={remove} data-testid="payee-delete-confirm">Evet, sil</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}